/**
 * Utility class for array operations
 */
export class ArrayUtils {
    /**
     * Sorts dropdown values alphabetically by name property
     * Separates "No Data Found" items and places them at the end
     * @param values Array of objects with name property
     * @param noDataFoundValue Optional value to identify "No Data Found" items (defaults to "No Data Found")
     * @returns Sorted array with regular items first, then "No Data Found" items
     */
    static sortDropdownValues(values: any[], noDataFoundValue: string = 'No Data Found'): any[] {
        if (!values || values.length === 0) return values;

        const getSortKey = (item: any) => {
            if (item == null) return '';
            if (typeof item === 'string') return item;
            return (item.name ?? '').toString();
        };

        const noDataItems = values.filter(item => getSortKey(item) === noDataFoundValue);
        const regularItems = values.filter(item => getSortKey(item) !== noDataFoundValue);

        const sortedRegularItems = regularItems.sort((a, b) => {
            const nameA = getSortKey(a).toLowerCase();
            const nameB = getSortKey(b).toLowerCase();
            return nameA.localeCompare(nameB);
        });

        return [...sortedRegularItems, ...noDataItems];
    }
}

